<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion-carta' }">{{
                $t("configuracionCarta")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'productos-carta' }">{{
                $t("productosCarta")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ action }} {{ $t("productoCarta") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <vue-tabs>
            <v-tab :title="$t('basico')">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="nombreProducto"
                          ><strong>{{ $t("nombre") }}</strong>
                          <span class="text-danger">*</span></label>
                          <input
                          type="text"
                          class="form-control"
                          id="nombreProducto"
                          v-model="producto.nameProducto"
                          maxlenght="127" />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(127, producto.nameProducto.length) }}</span>
                          </em>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group" v-if="!esSelfi">
                        <label
                          ><strong>{{ $t("referenciaProductoTpv") }}</strong>
                          <span style="color: red">*</span></label
                        >
                        <el-select
                          class="select-default"
                          v-model="producto.idProduct"
                          filterable
                          remote
                          reserve-keyword
                          :remote-method="searchProducto"
                          :placeholder="$t('nombreDelProductoEnElTpv')"
                        >
                          <el-option
                            v-for="p in listProductos"
                            :key="p.id"
                            :label="p.name"
                            :value="p.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label
                          ><strong>{{ $t("categoria") }}</strong>
                          <span style="color: red">*</span></label
                        >

                        <el-select
                          class="select-default"
                          size="large"
                          v-model="producto.idCategoria"
                          filterable
                          :placeholder="$t('seleccionaCategoria')"
                        >
                          <el-option
                            v-for="cat in listCategories"
                            class="select-primary"
                            :value="cat.id"
                            :label="cat.nombre"
                            :key="cat.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group" v-if="!esSelfi">
                        <label><strong>Tipo producto</strong> </label>

                        <el-select
                          class="select-default"
                          size="large"
                          v-model="tipo_producto"
                          filterable
                          :placeholder="$t('seleccionaTipo')"

                          
                        >
                          <el-option
                            class="select-primary"
                            :label="'Sin definir'"
                            :value="'Sin definir'"

                          >
                          </el-option>

                          <el-option
                              v-if="listRestricciones.length >0"
                            class="select-primary"
                            :value="'Alcohol'"
                            :label="'Alcohol'"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-12" v-if="!esSelfi">
                      <div class="form-group">
                        <label><strong>Tipo venta </strong> </label>

                        <el-select
                          class="select-default"
                          size="large"
                          v-model="producto.idTipo"
                          filterable
                          :placeholder="$t('seleccionaTipo')"
                        >
                          <el-option
                            v-for="obj in listTipoProducto"
                            class="select-primary"
                            :value="obj.value"
                            :label="obj.label"
                            :key="obj.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="descripcionProductoEditar"
                          ><strong>{{ $t("descripcion") }}</strong>
                        </label>
                        <input
                        id="descripcionProductoEditar"
                        v-model="producto.descripcion"
                          class="form-control"
                          maxlength="200"
                          />
                        <em>
                          <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(200, producto.descripcion.length) }}</span>
                        </em>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group" v-tooltip.right="$t('tolTipOrdenProducto')">
                        <label for="ordenProductoCarta"
                          ><strong>{{ $t("orden") }}</strong></label
                        >
                        <input
                          type="number"
                          min="0"
                          id="ordenProductoCarta"
                          v-model="producto.orden"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-md-4" v-if="!esSelfi">
                      <div class="form-group">
                        <label for="minExtras"
                          ><strong>{{
                            $t("nIngredientesSinCosto")
                          }}</strong></label
                        >
                        <input
                          type="number"
                          min="0"
                          id="minExtras"
                          v-model="producto.minExtras"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-md-4" v-if="!esSelfi">
                      <div class="form-group">
                        <label for="maxExtras"
                          ><strong>{{ $t("maximoExtras") }}</strong></label
                        >
                        <input
                          type="number"
                          min="0"
                          id="maxExtras"
                          v-model="producto.maxExtras"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-md-4" v-if="!esSelfi">
                      <div class="form-group">
                        <label for="maxOpcionales"
                          ><strong>{{ $t("maximoOpcionales")}}</strong></label
                        >
                        <input 
                          type="number"
                          min="0"
                          id="maxOpcionales"
                          v-model="producto.maxOpcionales"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <label
                        ><strong>{{ $t("alergenos") }}</strong></label
                      >
                      <div class="form-group">
                        <img
                          v-for="aler in producto.alergenos"
                          v-tooltip.top-center="aler.name"
                          @click="aler.active = aler.active ? false : true"
                          :style="[!aler.active ? { opacity: '0.3' } : {}]"
                          style="margin-left: 1%; cursor: pointer"
                          width="5%"
                          :src="'static/img/alergenos_icon/' + aler.id + '.png'"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("baja") }}</strong>
                        </label>
                        <el-switch
                          v-tooltip.right="$t('tolTipBaja')"
                          v-model="producto.baja"
                          active-color="#13ce66"
                          inactive-color="#bcbcbc"
                        >
                        </el-switch>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("disponible") }}</strong>
                        </label>
                        <el-switch
                          v-tooltip.right="$t('tolTipDisponible')"  
                          v-model="producto.noDisponible"
                          active-color="#13ce66"
                          inactive-color="#bcbcbc"
                        >
                        </el-switch>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <i
                          :class="
                            !producto.destacado
                              ? 'destaFalse fas fa-lg fa-star'
                              : 'fas fa-lg fa-star destaTrue'
                          "
                        />

                        <label>
                          <strong>{{ $t("destacado") }}</strong>
                        </label>
                        <el-switch v-tooltip.right="$t('tolTipProductoDestacado')"
                          v-model="producto.destacado"
                          active-color="#13ce66"
                          inactive-color="#bcbcbc"
                          v-on:click="destacar(!producto.destacado)"
                        >
                        </el-switch>
                      </div>
                    </div>

                    <div class="col-md-6" v-if="!esSelfi">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("sugerido") }}</strong>
                        </label>
                        <el-switch
                          v-model="producto.sugerido"
                          active-color="#13ce66"
                          inactive-color="#bcbcbc"
                        >
                        </el-switch>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="!esSelfi">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t('noMostrarSuelto') }}</strong>
                        </label>
                        <el-switch
                          v-model="producto.noMostrarSuelto"
                          active-color="#13ce66"
                          inactive-color="#bcbcbc"
                        >
                        </el-switch>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div v-if="distinguirPrecios && distinguirPreciosCarta && !esSelfi">
                    <span style="color: #1E22AA;font-weight: bold;">{{
                      $t("aRecoger")
                    }}</span>
                    <hr />
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifa1"
                            ><strong>{{ $t("nombreTarifa1") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar1"
                            v-model="producto.nameTarifa1"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa1.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa1"
                            ><strong>{{ $t("precioTarifa1") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa1"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar2"
                            ><strong>{{ $t("nombreTarifa2") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar2"
                            v-model="producto.nameTarifa2"
                            class="form-control"
                            maxlength="50"
                          />
                        <em>
                          <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa2.length) }}</span>
                        </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa2"
                            ><strong>{{ $t("precioTarifa2") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa2"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar3"
                            ><strong>{{ $t("nombreTarifa3") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar3"
                            v-model="producto.nameTarifa3"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa3.length) }}</span>
                          </em> 
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa3"
                            ><strong>{{ $t("precioTarifa3") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa3"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar4"
                            ><strong>{{ $t("nombreTarifa4") }} </strong></label
                          >
                          <input
                            id="nameTarifaEditar4"
                            v-model="producto.nameTarifa4"
                            class="form-control"
                            maxlength="50"
                          />
                        <em>
                          <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa4.length) }}</span>
                        </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa4"
                            ><strong>{{ $t("precioTarifa4") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa4"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                    </div>
                    <br />
                    <span style="color: #1E22AA;font-weight: bold;">{{
                      $t("aDomicilio")
                    }}</span>
                    <hr />
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifa1"
                            ><strong>{{ $t("nombreTarifa1") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar1"
                            v-model="producto.nameTarifa1_d"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa1_d.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa1"
                            ><strong>{{ $t("precioTarifa1") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa1_d"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar2"
                            ><strong>{{ $t("nombreTarifa2") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar2"
                            v-model="producto.nameTarifa2_d"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa2_d.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa2"
                            ><strong>{{ $t("precioTarifa2") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa2_d"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar3"
                            ><strong>{{ $t("nombreTarifa3") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar3"
                            v-model="producto.nameTarifa3_d"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa3_d.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa3"
                            ><strong>{{ $t("precioTarifa3") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa3_d"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar4"
                            ><strong>{{ $t("nombreTarifa4") }} </strong></label
                          >
                          <input
                            id="nameTarifaEditar4"
                            v-model="producto.nameTarifa4_d"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa4_d.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa4"
                            ><strong>{{ $t("precioTarifa4") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa4_d"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <!--<div class="col-md-12" v-if="!producto.img">
                        <template>
                          <div class="form-group">
                            <label
                              ><strong>{{ $t("imagen") }}</strong>
                              <span style="color: red">*</span></label
                            >
                            <input
                              class="form-control"
                              type="file"
                              @change="onFileChange"
                            />
                            <br />
                          </div>
                        </template>
                      </div>-->
                    </div>
                    <br />
                    <span style="color: #1E22AA;font-weight: bold;">{{
                      $t("cartaDigital")
                    }}</span>
                    <hr />
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifa1"
                            ><strong>{{ $t("nombreTarifa1") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar1"
                            v-model="producto.nameTarifa1_c"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa1_c.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa1"
                            ><strong>{{ $t("precioTarifa1") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa1_c"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar2"
                            ><strong>{{ $t("nombreTarifa2") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar2"
                            v-model="producto.nameTarifa2_c"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa2_c.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa2"
                            ><strong>{{ $t("precioTarifa2") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa2_c"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar3"
                            ><strong>{{ $t("nombreTarifa3") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar3"
                            v-model="producto.nameTarifa3_c"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa3_c.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa3"
                            ><strong>{{ $t("precioTarifa3") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa3_c"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar4"
                            ><strong>{{ $t("nombreTarifa4") }} </strong></label
                          >
                          <input
                            id="nameTarifaEditar4"
                            v-model="producto.nameTarifa4_c"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa4_c.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa4"
                            ><strong>{{ $t("precioTarifa4") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa4_c"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="!producto.img">
                        <template>
                          <div class="form-group">
                            <label
                              ><strong>{{ $t("imagen") }}</strong>
                              <span style="color: red">*</span></label
                            >
                            <input
                              class="form-control"
                              type="file"
                              @change="onFileChange"
                            />
                            <br />
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="distinguirPrecios">
                    <span style="color: #1E22AA;font-weight: bold;">{{
                      $t("aRecoger")
                    }}</span>
                    <hr />
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifa1"
                            ><strong>{{ $t("nombreTarifa1") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar1"
                            v-model="producto.nameTarifa1"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa1.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa1"
                            ><strong>{{ $t("precioTarifa1") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa1"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar2"
                            ><strong>{{ $t("nombreTarifa2") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar2"
                            v-model="producto.nameTarifa2"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa2.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa2"
                            ><strong>{{ $t("precioTarifa2") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa2"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar3"
                            ><strong>{{ $t("nombreTarifa3") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar3"
                            v-model="producto.nameTarifa3"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa3.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa3"
                            ><strong>{{ $t("precioTarifa3") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa3"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar4"
                            ><strong>{{ $t("nombreTarifa4") }} </strong></label
                          >
                          <input
                            id="nameTarifaEditar4"
                            v-model="producto.nameTarifa4"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa4.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa4"
                            ><strong>{{ $t("precioTarifa4") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa4"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                    </div>
                    <br />
                    <span style="color: #1E22AA;font-weight: bold;">{{
                      $t("aDomicilio")
                    }}</span>
                    <hr />
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifa1"
                            ><strong>{{ $t("nombreTarifa1") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar1"
                            v-model="producto.nameTarifa1_d"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa1_d.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa1"
                            ><strong>{{ $t("precioTarifa1") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa1_d"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar2"
                            ><strong>{{ $t("nombreTarifa2") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar2"
                            v-model="producto.nameTarifa2_d"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa2_d.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa2"
                            ><strong>{{ $t("precioTarifa2") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa2_d"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar3"
                            ><strong>{{ $t("nombreTarifa3") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar3"
                            v-model="producto.nameTarifa3_d"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa3_d.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa3"
                            ><strong>{{ $t("precioTarifa3") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa3_d"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar4"
                            ><strong>{{ $t("nombreTarifa4") }} </strong></label
                          >
                          <input
                            id="nameTarifaEditar4"
                            v-model="producto.nameTarifa4_d"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa4_d.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa4"
                            ><strong>{{ $t("precioTarifa4") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa4_d"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="!producto.img">
                        <template>
                          <div class="form-group">
                            <label
                              ><strong>{{ $t("imagen") }}</strong>
                              <span style="color: red">*</span></label
                            >
                            <input
                              class="form-control"
                              type="file"
                              @change="onFileChange"
                            />
                            <br />
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="distinguirPreciosCarta">
                    <span style="color: #1E22AA;font-weight: bold;">Pedidos</span>
                    <hr />
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifa1"
                            ><strong>{{ $t("nombreTarifa1") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar1"
                            v-model="producto.nameTarifa1"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa1.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa1"
                            ><strong>{{ $t("precioTarifa1") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa1"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar2"
                            ><strong>{{ $t("nombreTarifa2") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar2"
                            v-model="producto.nameTarifa2"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa2.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa2"
                            ><strong>{{ $t("precioTarifa2") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa2"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar3"
                            ><strong>{{ $t("nombreTarifa3") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar3"
                            v-model="producto.nameTarifa3"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa3.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa3"
                            ><strong>{{ $t("precioTarifa3") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa3"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar4"
                            ><strong>{{ $t("nombreTarifa4") }} </strong></label
                          >
                          <input
                            id="nameTarifaEditar4"
                            v-model="producto.nameTarifa4"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa4.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa4"
                            ><strong>{{ $t("precioTarifa4") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa4"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                    </div>
                    <br />
                    <span style="color: #1E22AA;font-weight: bold;">{{
                      $t("carta")
                    }}</span>
                    <hr />
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifa1"
                            ><strong>{{ $t("nombreTarifa1") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar1"
                            v-model="producto.nameTarifa1_c"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa1_c.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa1"
                            ><strong>{{ $t("precioTarifa1") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa1_c"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar2"
                            ><strong>{{ $t("nombreTarifa2") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar2"
                            v-model="producto.nameTarifa2_c"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa2_c.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa2"
                            ><strong>{{ $t("precioTarifa2") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa2_c"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar3"
                            ><strong>{{ $t("nombreTarifa3") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar3"
                            v-model="producto.nameTarifa3_c"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa3_c.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa3"
                            ><strong>{{ $t("precioTarifa3") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa3_c"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar4"
                            ><strong>{{ $t("nombreTarifa4") }} </strong></label
                          >
                          <input
                            id="nameTarifaEditar4"
                            v-model="producto.nameTarifa4_c"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa4_c.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa4"
                            ><strong>{{ $t("precioTarifa4") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa4_c"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="!producto.img">
                        <template>
                          <div class="form-group">
                            <label
                              ><strong>{{ $t("imagen") }}</strong>
                              <span style="color: red">*</span></label
                            >
                            <input
                              class="form-control"
                              type="file"
                              @change="onFileChange"
                            />
                            <br />
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifa1"
                            ><strong>{{ $t("nombreTarifa1") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar1"
                            v-model="producto.nameTarifa1"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa1.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa1"
                            ><strong>{{ $t("precioTarifa1") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa1"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar2"
                            ><strong>{{ $t("nombreTarifa2") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar2"
                            v-model="producto.nameTarifa2"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa2.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa2"
                            ><strong>{{ $t("precioTarifa2") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa2"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar3"
                            ><strong>{{ $t("nombreTarifa3") }}</strong></label
                          >
                          <input
                            id="nameTarifaEditar3"
                            v-model="producto.nameTarifa3"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa3.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa3"
                            ><strong>{{ $t("precioTarifa3") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa3"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nameTarifaEditar4"
                            ><strong>{{ $t("nombreTarifa4") }} </strong></label
                          >
                          <input
                            id="nameTarifaEditar4"
                            v-model="producto.nameTarifa4"
                            class="form-control"
                            maxlength="50"
                          />
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.nameTarifa4.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa4"
                            ><strong>{{ $t("precioTarifa4") }}</strong></label
                          >
                          <vue-numeric
                            currency="€"
                            inputmode="decimal"
                            type="text"
                            class="form-control"
                            currency-symbol-position="suffix"
                            :precision="2"
                            v-model="producto.precioTarifa4"
                            @keydown.native="$methods.evitarComasDecimales"
                          >
                          </vue-numeric>
                        </div>
                      </div>
                      <!-- Aquí es donde se muestra  -->
                      <div class="col-md-12">
                          <template>
                              <div class="form-group" v-tooltip.right="$t('tolTipImagenProducto')">
                                  <label><strong>{{ $t("imagen") }}</strong><span style="color: red">*</span></label>
                                  <div style="margin-bottom: 5px;">
                                    <img v-if="producto.img && !img.length" 
                                        :src="producto.img" 
                                        alt="producto imágen preview" 
                                        class="img-thumbnail"
                                        @error="imagenNoEncontrada"
                                        style="max-width: 130px; max-height: 130px;" />
                                    <!-- Muestra la vista previa de la imagen seleccionada -->
                                    <img v-else-if="img" 
                                        :src="img" 
                                        alt="File Preview" 
                                        class="img-thumbnail"
                                        style="max-width: 130px; max-height: 130px;" />
                                  </div>
                                  <input id="1" class="form-control" type="file" @change="onFileChange" />
                              </div>
                          </template>
                      </div>
                      <!-- <div class="col-md-12">
                        <template>
                          <div class="form-group">
                            <label
                              ><strong>{{ $t("imagen") }}</strong>
                              <span style="color: red">*</span></label
                            >
                            <input
                              class="form-control"
                              type="file"
                              @change="onFileChange"
                            />
                            <br />
                          </div>
                        </template>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>
            <v-tab :title="$t('avanzado')" v-if="!esSelfi">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="opcion1"
                    ><strong>{{
                      $t("opcionesAlSeleccionarElArticulo")
                    }}</strong></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="opcion1"
                    v-bind:placeholder="$t('opcion1')"
                    v-model="producto.opcion1"
                    maxlength="50"
                  />
                  <em>
                    <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.opcion1.length) }}</span>
                  </em>
                  <input
                    style="margin-top: 10px"
                    type="text"
                    class="form-control"
                    id="opcion2"
                    v-bind:placeholder="$t('opcion2')"
                    v-model="producto.opcion2"
                    maxlength="50"
                  />
                  <em>
                    <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.opcion2.length) }}</span>
                  </em>
                  <input
                    style="margin-top: 10px"
                    type="text"
                    class="form-control"
                    id="opcion3"
                    v-bind:placeholder="$t('opcion3')"
                    v-model="producto.opcion3"
                    maxlength="50"
                  />
                  <em>
                    <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.opcion3.length) }}</span>
                  </em>
                  <input
                    style="margin-top: 10px"
                    type="text"
                    class="form-control"
                    id="opcion4"
                    v-bind:placeholder="$t('opcion4')"
                    v-model="producto.opcion4"
                    maxlength="50"
                  />
                  <em>
                    <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.opcion4.length) }}</span>
                  </em>
                  <input
                    style="margin-top: 10px"
                    type="text"
                    class="form-control"
                    id="opcion5"
                    v-bind:placeholder="$t('opcion5')"
                    v-model="producto.opcion5"
                    maxlength="50"
                  />
                  <em>
                    <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(50, producto.opcion5.length) }}</span>
                  </em>
                </div>
              </div>
            </v-tab>
            <v-tab v-if="idProducto && !esSelfi" :title="$t('materiasPrimas')">
              <div class="row">
                <div class="col-md-12">
                  <button
                    @click="$modal.show('modal-copysub')"
                    class="btn btn-warning"
                  >
                    <i class="fas fa-exchange-alt"></i>
                    {{ $t("copiarMateriasPrimas") }}
                  </button>
                </div>

                <div class="col-md-12">
                  <div>
                    <table class="table table-bordered table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th>{{ $t("nombre") }}</th>
                          <th>{{ $t("tipo") }}</th>
                          <th>{{ $t("variacion") }}</th>
                          <th>{{ $t("acciones") }}</th>
                          <th v-tooltip.right="$t('tooltipBaseExtra')">{{ $t("extrasFree") }} 
                            <i class="el-icon-warning" style="font-size: 16px; align-items: center;"></i>
                            <br/>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="bg-add-subproduct">
                          <td colspan="11">
                            <el-select
                              class="select-default"
                              v-model="idMateriaPrima"
                              filterable
                              clearable
                              style="width: 100%"
                              remote
                              reserve-keyword
                              @change="addMateriaPrima()"
                              :placeholder="$t('buscarNombreDeLaMateriaPrima')"
                              :remote-method="searchMateriasPrimasCarta"
                            >
                              <el-option
                                v-for="p in listSearchMateriasPrimas"
                                :key="p.id"
                                :label="p.name"
                                :value="p.id"
                              >
                              </el-option>
                            </el-select>
                          </td>
                        </tr>
                        <tr v-for="mat in listMateriasPrimas">
                          <td width="40%">{{ mat.nombre }}</td>
                          <td>
                            <el-select
                              class="select-default"
                              size="large"
                              @visible-change="changeTipo(1, mat)"
                              @change="changeTipo(2, mat)"
                              v-model="mat.tipo"
                              :placeholder="$t('seleccionaTipoPunto')"
                            >
                              <el-option
                                v-for="t in listaTipo"
                                class="select-primary"
                                :value="t.value"
                                :label="t.label"
                                :key="t.value"
                              >
                              </el-option>
                            </el-select>
                          </td>
                          <td>
                            <vue-numeric
                              currency="€"
                              :id="'variacion' + mat.id"
                              inputmode="decimal"
                              type="text"
                              class="form-control"
                              @blur="guardarMateriaPrimaByProductosCarta(mat)"
                              currency-symbol-position="suffix"
                              :precision="2"
                              v-model="mat.variacion_precio"
                              @keydown.native="$methods.evitarComasDecimales"
                            ></vue-numeric>
                          </td>

                          <td align="center">
                            <el-button
                              @click="eliminarSubproducto(mat.id)"
                              circle
                            >
                              <i class="fas fa-trash-alt"></i>
                            </el-button>
                          </td>
                          <!-- 
                            Lo que hará esta función es básicamente que si está en true y tienes la configuración de suma bases ( quitar base y añades extra gratis )
                            si está en true cuando se quite dicha base no se añadirá un extra free a los extras.
                          -->
                          <!-- EXTRAS -->
                          <!-- Esta función si está en true, hará que este extra no se añada como free aunque tenga precio 0.0 o precio 0 < precio. -->
                          <td align="center">
                            <el-switch
                              v-if="mat.tipo.toUpperCase() == 'E' || (mat.tipo.toUpperCase() == 'B' ? restarBase : false)"  
                              v-model="mat.notFree"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                @change="changeState(mat)"
                                >
                            </el-switch>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </v-tab>
            <v-tab v-if="tieneMulticanal" :title="'Conf. Avanzada Sinqro'">
              <div class="row">
                <div class="col-md-12">
                  <label
                    >Plataformas de venta en las que estará disponible:</label
                  >
                  <br />
                  <br />
                  <div class="d-flex justify-content-start flex-wrap">
                    <div
                      v-for="agencia in listAgencias"
                      :key="'agenciaid' + agencia.id"
                    >
                      <el-checkbox
                        :style="
                          'min-width: 120px !important; margin-right: 15px;'
                        "
                        v-model="agencia.checked"
                        :label="agencia.nombreCanal"
                        border
                      >
                      </el-checkbox>
                    </div>
                  </div>
                  <br />
                  <small
                    >* Recuerda que los precios para la plataforma de venta de
                    NumierPEDIDOS se configuran en la pestaña "Básico".</small
                  >
                  <br />
                  <div class="card">
                    <div
                      v-for="producto in listProductosAgencias"
                      :key="'productoagenciaid' + producto.idProductAgencia"
                    >
                      <h4>
                        <img
                          v-if="producto.nombreCanal"
                          :src="
                            require('@/assets/img/' +
                              producto.nombreCanal +
                              '.svg')
                          "
                          style="width: 40px"
                        />
                        {{ producto.nombreCanal }}
                      </h4>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="nameTarifa1"
                              ><strong>Nombre</strong></label
                            >
                            <input
                              id="nameTarifaEditar1"
                              disabled
                              :value="nombreProducto"
                              class="form-control"
                              maxlength="127"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="precioTarifa1"
                              ><strong>Precio</strong></label
                            >
                            <vue-numeric
                              currency="€"
                              inputmode="decimal"
                              type="text"
                              class="form-control"
                              currency-symbol-position="suffix"
                              :precision="2"
                              v-model="producto.price1"
                            >
                            </vue-numeric>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="nameTarifaEditar2"
                              ><strong>Nombre de la variante 1</strong>
                              <span style="margin-left: 10px">
                                <i
                                  v-tooltip.top-center="tipNombreVariante"
                                  style="white"
                                  class="fa fa-info-circle"
                                >
                                </i>
                              </span>
                            </label>
                            <input
                              id="nameTarifaEditar2"
                              v-model="producto.namePrice2"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="precioTarifa2"
                              ><strong>Precio de la variante 1</strong></label
                            >
                            <vue-numeric
                              currency="€"
                              inputmode="decimal"
                              type="text"
                              class="form-control"
                              currency-symbol-position="suffix"
                              :precision="2"
                              v-model="producto.price2"
                            >
                            </vue-numeric>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="nameTarifaEditar3"
                              ><strong>Nombre de la variante 2</strong>
                              <span style="margin-left: 10px">
                                <i
                                  v-tooltip.top-center="tipNombreVariante"
                                  style="white"
                                  class="fa fa-info-circle"
                                >
                                </i>
                              </span>
                            </label>
                            <input
                              id="nameTarifaEditar3"
                              v-model="producto.namePrice3"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="precioTarifa3"
                              ><strong>Precio de la variante 2</strong></label
                            >
                            <vue-numeric
                              currency="€"
                              inputmode="decimal"
                              type="text"
                              class="form-control"
                              currency-symbol-position="suffix"
                              :precision="2"
                              v-model="producto.price3"
                            >
                            </vue-numeric>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="nameTarifaEditar4"
                              ><strong>Nombre de la variante 3</strong>
                              <span style="margin-left: 10px">
                                <i
                                  v-tooltip.top-center="tipNombreVariante"
                                  style="white"
                                  class="fa fa-info-circle"
                                >
                                </i>
                              </span>
                            </label>
                            <input
                              id="nameTarifaEditar4"
                              v-model="producto.namePrice4"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="precioTarifa4"
                              ><strong>Precio de la variante 3</strong></label
                            >
                            <vue-numeric
                              currency="€"
                              inputmode="decimal"
                              type="text"
                              class="form-control"
                              currency-symbol-position="suffix"
                              :precision="2"
                              v-model="producto.price4"
                            >
                            </vue-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>
          </vue-tabs>
          <div>
            <button class="btn btn-primary" @click="saveProducto()">
              <i class="fa fa-check-square"></i> {{ $t("guardar") }}
            </button>
            <router-link :to="{ name: 'productos-carta' }">
              <button class="btn btn-danger">
                <i class="fa fa-window-close"></i>
                {{ $t("cancelar") }}
              </button>
            </router-link>
            <button v-if="this.idProducto" class="btn btn-google" @click="clonarProductoCarta()">
              <i class="fas fa-exchange-alt"></i> {{ $t("clonarProductoCarta") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <modal
      name="modal-copysub"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="true"
    >
      <div>
        <div class="modal-header" style="padding-bottom: 0px">
          <h5>{{ $t("copiarMateriaPrima") }}</h5>
        </div>
        <div class="modal-body" style="padding-top: 0px">
          1 - {{ $t("seleccioneQueTipoDeMateriasPrimasQuiereCopiar") }}

          <el-checkbox-group v-model="listTipo" style="margin-top: 5px">
            <div class="col-md-12">
              <el-checkbox :label="$t('bases')" key="0"></el-checkbox>
              <el-checkbox :label="$t('opcionales')" key="1"></el-checkbox>
              <el-checkbox :label="$t('extras')" key="2"></el-checkbox>
            </div>
          </el-checkbox-group>

          <hr />

          2 - {{ $t("seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas") }}
          <el-checkbox-group
            v-model="listcategoriesCopySub"
            style="margin-top: 5px"
          >
            <div class="col-md-12" v-for="c in listCategories">
              <el-checkbox :label="c.id" :key="c.id">
                {{ c.nombre }}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="showModalCopySub()" class="btn btn-primary">
              <i class="fa fa-check-square"></i> {{ $t("guardar") }}
            </button>
            <button
              @click="$modal.hide('modal-copysub')"
              class="btn btn-danger"
            >
              <i class="fa fa-window-close"></i>
              {{ $t("cancelar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  CheckboxGroup,
  Checkbox,
  DropdownMenu,
  Button,
  Switch,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

export default {
  name: "ConfiguracionCartaForm",
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Switch.name]: Switch,
  },
  created() {
    this.getRestriccionesProductCartaByTpv();
    this.getCategoriesCarta();
    if (this.idProducto) {
      this.getProductoCarta();
      this.getMateriasPrimasByProduct();
    }

    this.action = this.idProducto
      ? this.$i18n.t("editar")
      : this.$i18n.t("nuevo");

    this.getConfigTpv();
    this.getConfigTpvCarta();
    this.getConfiguracionTpv();
    this.getConfiguracionRestarBase();
    this.checkIsSelfi();
  },
  data() {
    return {
      listRestricciones: [],
      tipo_producto: "Selecciona tipo",
      show: true,
      action: "",
      distinguirPrecios: false,
      distinguirPreciosCarta: false,
      idProducto: this.$route.params.idProducto,
      idBusiness: this.$route.params.idBusiness,
      idCarta: this.$route.params.idCarta,
      producto: {
        idTipo: "",
        maxExtras: 0,
        minExtras: 0,
        maxOpcionales: 0,
        orden: 999,
        nameProducto: "",
        descripcion: "",
        img: "",
        idProduct: "",
        baja: false,
        idCategoria: 0,
        noDisponible: false,
        //TARIFAS
        nameTarifa1: "",
        nameTarifa2: "",
        nameTarifa3: "",
        nameTarifa4: "",
        precioTarifa1: "",
        precioTarifa2: "",
        precioTarifa3: "",
        precioTarifa4: "",
        nameTarifa1: "",
        nameTarifa2: "",
        nameTarifa3: "",
        nameTarifa4: "",
        nameTarifa1_d: "",
        nameTarifa2_d: "",
        nameTarifa3_d: "",
        nameTarifa4_d: "",
        precioTarifa1_d: 0,
        precioTarifa2_d: 0,
        precioTarifa3_d: 0,
        precioTarifa4_d: 0,
        nameTarifa1_c: "",
        nameTarifa2_c: "",
        nameTarifa3_c: "",
        nameTarifa4_c: "",
        precioTarifa1_c: 0,
        precioTarifa2_c: 0,
        precioTarifa3_c: 0,
        precioTarifa4_c: 0,
        opcion1: "",
        opcion2: "",
        opcion3: "",
        opcion4: "",
        opcion5: "",
        alergenos: [
          { id: 1, name: this.$t("cereales"), active: false },
          { id: 2, name: this.$t("crustaceos"), active: false },
          { id: 3, name: this.$t("huevos"), active: false },
          { id: 4, name: this.$t("pescado"), active: false },
          { id: 5, name: this.$t("cacahuetes"), active: false },
          { id: 6, name: this.$t("soja"), active: false },
          { id: 7, name: this.$t("leche"), active: false },
          { id: 8, name: this.$t("frutosDeCascara"), active: false },
          { id: 9, name: this.$t("apio"), active: false },
          { id: 10, name: this.$t("mostaza"), active: false },
          { id: 11, name: this.$t("granosDeSesamo"), active: false },
          { id: 12, name: this.$t("dioxidoDeAzufre"), active: false },
          { id: 13, name: this.$t("altramuces"), active: false },
          { id: 14, name: this.$t("moluscos"), active: false },
        ],
      },
      listProductos: [],
      listCategories: [],
      img: "",

      listTipoProducto: [
        {
          value: "",
          label: this.$t("todos"),
        },
        {
          value: "P",
          label: this.$t("pedidos"),
        },
        {
          value: "C",
          label: this.$t("cartaASecas"),
        },
        {
          value: "M",
          label: this.$t("mesa"),
        },
      ],

      //MATERIAS PRIMAS
      listaTipo: [
        { label: this.$t("base"), value: "B" },
        { label: this.$t("extra"), value: "E" },
        { label: this.$t("opcional"), value: "O" },
      ],
      listMateriasPrimas: [],
      listSearchMateriasPrimas: [],
      idMateriaPrima: "",
      tipoAnterior: "",
      tieneMulticanal: false,
      restarBase: false,
      listAgencias: [],
      listProductosAgencias: [],
      //COPYSUB
      listTipo: [],
      listcategoriesCopySub: [],
      nombreProducto: "",
      loading: "",
      tipNombreVariante: `¡Cuidado! No incluyas el nombre "base" del producto en el nombre de las variantes, ya que en Sinqro aparecería repetido el nombre dos veces. Si el nombre del producto es "Patatas fritas" utiliza "Grande" o "Deluxe" como nombre de variante.`,
      esSelfi : false,
    };
  },
  watch: {
    "producto.nameProducto": function(newVal, oldVal) {
      this.nombreProducto = newVal;
    },
  },
  methods: {
    
    changeState(valor) {

      var config = {
          params: {
            idProductSubProductsCarta: valor.id,
            value: valor.notFree,
            jwt: this.$store.getters.jwt,
            tipo: valor.tipo,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          idProductSubProductsCarta: valor.id,
          value: valor.notFree,
          jwt: this.$store.getters.jwt,
          tipo: valor.tipo,
        };
      
        let vm = this;


        this.axios
          .post(
            this.$store.getters.apiUrl + "delivery/" + 'updateMateriaPrimaById',
            params,
            config
          )
          .then(function(response) {
            if (response.data.response) {
              let notify = vm.$t("editado");
              vm.$notify({
                message:
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            vm.inProgress = false;
          });      
    },

    calculateNumberOfCharacters(total, lenght) {
        return total - lenght;
    },
    imagenNoEncontrada(event) {
      // Manejar el evento de error de carga de la imagen
      event.target.onerror = null; // Evitar bucle infinito
      event.target.src = 'https://www.numier.com/wp-content/themes/arkahost/assets/images/default404.jpg';
    },

    checkIsSelfi() {
      let vm = this;

      const esSelfiCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("esSelfi="));

      // Verificar si la cookie existe antes de intentar acceder a su valor
      if (esSelfiCookie) {
        vm.esSelfi = esSelfiCookie.split("=")[1];
      } else {
        vm.esSelfi = false;
      }
    },

    clonarProductoCarta(){
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      console.log(this.productscarta);
      var params = {
        idProductCarta: this.idProducto,
        productscarta: this.producto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "cloneProductCarta";

      this.axios
          .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if(response.data.response){
            vm.$notify({
              message: vm.$t("productosCopiadosCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$router.push({
              name: "producto-carta",
              params: {
                idBusiness: vm.idBusiness,
                idProducto: response.data.result,
              },
            });

            vm.idProducto = response.data.result;
            vm.getProductoCarta();
            vm.getMateriasPrimasByProduct();
           

          }else{
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error){
          console.log(error);
          vm.inProgress = false;
        });
    },

     getRestriccionesProductCartaByTpv() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "delivery/getRestriccionProductsCarta",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.listRestricciones = response.data.result;
            vm.respuesta = true;
          }
        });
    },
    destacar(accion) {
      this.producto.destacado = accion;
      this.show = accion;
    },

    keydown: function(event, event2) {
      if (event.keyCode != 229) {
        console.log(event);

        if (event.keyCode == 32 || event.keyCode == 188) {
          event.preventDefault();
        }
      }
    },
    showModalCopySub() {
      if (
        this.listcategoriesCopySub.length !== 0 &&
        this.listTipo.length !== 0
      ) {
        swal({
          title: this.$t(
            "estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos"
          ),
          text: this.$t("estaOperacionNoSePuedeDeshacer"),
          type: "info",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("aceptarProceso"),
          cancelButtonText: this.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.copySub();
          }
        });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("necesitasMarcarAlMenosUnTipoYUnaCategoria"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },

    //* Tiene la config restar base.
    getConfiguracionRestarBase() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 32,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.restarBase = true;
          } else {
            vm.restarBase = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },


    //ESTE METODO NOS PERMITE SABER SI EL CLIENTE TIENE LOS MULTICANALES
    getConfiguracionTpv() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 60,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.tieneMulticanal = true;
            vm.loading = Loading.service({
              text: "Sincronizando configuración Sinqro...",
            });
            //Como tiene multicanal recojo las agencias que tiene el businessinfo.
            vm.getAgenciasSinqro();
          } else {
            vm.tieneMulticanal = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getAgenciasSinqro() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getAgenciasSinqro", config)
        .then(function(response) {
          if (response.data.response) {
            response.data.result.forEach((respuesta) => {
              //Creamos las agencias con los datos que nos llegan

              const agencia = {
                checked: false,
                id: respuesta.id,
                idBusinessInfo: respuesta.idBusinessInfo,
                idCartaSinqro: respuesta.idSinqro,
                nombreCanal: respuesta.nombreCanal,
              };

              //Si alguna de ellas es Numier, la ponemos al principio de todo.

              if (respuesta.nombreCanal == "Numier") {
                vm.listAgencias = vm.listAgencias
                  .splice(0, 0, agencia)
                  .concat(vm.listAgencias);
              } else {
                //Si no es Numier, la añadimos de forma normal.
                vm.listAgencias.push(agencia);
              }
            });

            //vm.listAgencias = response.data.result;

            //Call API getProductsCartaAgenciasSinqro
            if (vm.idProducto) {
              vm.getProductsCartaAgenciaSinqro();
            } else {
              //Si no tiene idProducto es que es un producto nuevo y le marcamos por defecto Numier.
              vm.listAgencias.find((agencia) =>
                agencia.nombreCanal.includes("Numier")
              ).checked = true;

              //Además, por cada agencia que tenga, creamos entradas de "productscartaagenciassinqro"
              vm.listAgencias.forEach((agencia) => {
                //console.log(respuesta.idAgenciaSinqro);
                //console.log(agencia.id);
                const productoAgencia = {
                  idAgenciaSinqro: agencia.id,
                  nombreCanal: agencia.nombreCanal,
                  price1: 0,
                  price2: 0,
                  price3: 0,
                  price4: 0,
                  namePrice2: "",
                  namePrice3: "",
                  namePrice4: "",
                  checked: false,
                };
                //Excluimos a Numier porque no queremos crear un productscartaagenciassiqnro de Numier
                if (agencia.nombreCanal != "Numier") {
                  vm.listProductosAgencias.push(productoAgencia);
                }
              });

              vm.loading.close();
            }
          } else {
            vm.loading.close();
            swal({
              title: "Ha ocurrido un error inesperado",
              text: response.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getProductsCartaAgenciaSinqro() {
      var config = {
        params: {
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "products/getProductsCartaAgenciaSinqro",
          config
        )
        .then(function(response) {
          //console.log(response);
          if (response.data.response) {
            //Miramos si se está trayendo resultados
            if (
              response.data.result == undefined ||
              response.data.result.length == 0
            ) {
              //En caso negativo, marcamos Numier por defecto
              vm.listAgencias.find((agencia) =>
                agencia.nombreCanal.includes("Numier")
              ).checked = true;

              vm.rellenarConProductsAgencia();

              vm.loading.close();
            } else {
              //En caso positivo, recorremos el array de productos relacionados a agencias
              response.data.result.forEach((respuesta) => {
                vm.listAgencias.forEach((agencia) => {
                  //console.log(respuesta.idAgenciaSinqro);
                  //console.log(agencia.id);

                  if (respuesta.idAgenciaSinqro == agencia.id) {
                    respuesta.nombreCanal = agencia.nombreCanal;

                    if (respuesta.noDisponible == 1) {
                      agencia.checked = false;
                    } else {
                      agencia.checked = true;
                    }
                  }
                });

                if (
                  !response.data.result.some((e) => e.nombreCanal == "Numier")
                ) {
                  vm.listAgencias.find((agencia) =>
                    agencia.nombreCanal.includes("Numier")
                  ).checked = true;
                }

                if (respuesta.nombreCanal != "Numier") {
                  vm.listProductosAgencias.push(respuesta);
                }
              });

              vm.rellenarConProductsAgencia();
              vm.loading.close();
              //console.log(vm.listProductosAgencias);
            }
          } else {
            vm.loading.close();
            swal({
              title: "Ha ocurrido un error inesperado",
              text: response.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    rellenarConProductsAgencia() {
      this.listAgencias.forEach((agencia) => {
        //console.log(vm.listProductosAgencias.some(p => p.nombreCanal == agencia.nombreCanal));
        if (
          !this.listProductosAgencias.some(
            (p) => p.nombreCanal == agencia.nombreCanal
          )
        ) {
          if (agencia.nombreCanal != "Numier") {
            this.listProductosAgencias.push({
              id: this.idProducto,
              idProductAgencia: null,
              price1: this.producto.precioTarifa1,
              price2: this.producto.precioTarifa2,
              price3: this.producto.precioTarifa3,
              price4: this.producto.precioTarifa4,
              namePrice2: this.producto.nameTarifa2,
              namePrice3: this.producto.nameTarifa3,
              namePrice4: this.producto.nameTarifa4,
              idSinqro: "",
              importadoSinqro: "",
              idAgenciaSinqro: agencia.id,
              nombreCanal: agencia.nombreCanal,
            });
          }
        }
      });
    },
    copySub() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idProduct: this.idProducto,
        idBusiness: this.idBusiness,
        listCategories: this.listcategoriesCopySub,
        listTipo: this.listTipo,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "copySubCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("materiaPrimaCopiadaCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$modal.hide("modal-copysub");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    getProductoCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idProduct: this.idProducto,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl + "delivery/getProductsCartaById",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.tipo_producto = response.data.result.tipo_producto == 'A' ? "Alcohol" : "Sin definir"
            vm.producto = response.data.result;
            vm.searchProducto(vm.producto.nombreProductoRef);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getConfigTpv() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 55,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.distinguirPrecios = true;
          } else {
            vm.distinguirPrecios = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getConfigTpvCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 89,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.distinguirPreciosCarta = true;
          } else {
            vm.distinguirPreciosCarta = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getCategoriesCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getCategoriesCartaSinPadres", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listCategories = response.data.result;
            if (!vm.idProducto) {
              vm.producto.idCategoria = response.data.result[0].id;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    searchProducto(query) {
      if (query !== "") {
        const controller = "searchProductsTpv";
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
            query: query
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "delivery/" + controller, config)
          .then(function(response) {
            if (response.data.response) {
              vm.listProductos = response.data.result.products;
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length){
        return;
      }
      // this.createImage(files[0]);
      if (this.isValidImageFile(files[0])) {
          this.createImage(files[0]);
      } else {
          swal({
              title: "Error",
              text: "Por favor, seleccione un archivo JPG o PNG.",
              confirmButtonClass: 'btn btn-info btn-fill',
              type: 'error'
          });
      }
    },

    
    isValidImageFile(file) {
      // Array de extensiones permitidas
      const allowedExtensions = ["jpg", "png", "jpeg"];
      
      // Obtiene la extensión del archivo
      const fileName = file.name.toLowerCase();  // Agrega () aquí
      const fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1);
      
      // Verifica si la extensión está en la lista de extensiones permitidas
      return allowedExtensions.includes(fileExtension);
    },
    createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.img = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    
    saveProducto() {
      var vm = this;
      // if (!this.producto.img) {
      //   this.producto.editImage = true;

      //   this.producto.img = this.img;
      // }

      //* si ha seleccionado una imágen,se le otorgará la imágen seleccionada.
      if(vm.img){

        this.producto.editImage = true;

        
        this.producto.img = this.img;
         
      }

      if (this.tipo_producto == "Alcohol") {

        this.producto.tipo_producto = 'A';
        
      } else{
        this.producto.tipo_producto = ' ';
      }

      if (this.checkEditarProduct()) {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          idBusiness: this.idBusiness,
          producto: this.producto,
          jwt: this.$store.getters.jwt,
          idCarta: this.idCarta,
        };
      
        let vm = this;
        let controller = this.idProducto
          ? "editarProductoCarta"
          : "nuevoProductoCarta";

        this.axios
          .post(
            this.$store.getters.apiUrl + "delivery/" + controller,
            params,
            config
          )
          .then(function(response) {
            if (response.data.response) {
              if (vm.tieneMulticanal) {
                const agenciasMarcadas = vm.listAgencias; //vm.listAgencias.filter(agencia => {return agencia.checked == true});

                const productosAgenciaAMandar = [];

                agenciasMarcadas.forEach((agencia) => {
                  if (
                    vm.listProductosAgencias.some(
                      (p) => p.idAgenciaSinqro == agencia.id
                    )
                  ) {
                    const productoAgencia = vm.listProductosAgencias.find(
                      (producto) => producto.idAgenciaSinqro == agencia.id
                    );

                    productosAgenciaAMandar.push(productoAgencia);
                  }
                });

                vm.saveCanalesSinqro(
                  productosAgenciaAMandar,
                  response.data.result
                );
                //console.log(productosAgenciaAMandar);
                //console.log(vm.listAgencias);
              }

              vm.$router.push({
                name: "productos-carta",
                params: { idBusiness: vm.idBusiness },
              });

              let notify = vm.$t("editado");
              vm.$notify({
                message:
                  vm.$t("producto") +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    saveCanalesSinqro(productosAgencias, ultimaIdInsertada) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        listaAgencias: this.listAgencias,
        idBusiness: this.idBusiness,
        productosAgencias: productosAgencias,
        idProducto: this.idProducto ? this.idProducto : ultimaIdInsertada,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "saveCanalesSinqro";

      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            //Do nothing;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    checkEditarProduct() {
      var check = true;

      if (this.producto.nameProducto === "") {
        swal({
          title: this.$t("atencion"),
          text: "Rellene los campos obligatorios",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        check = false;
      }

      return check;
    },

    searchMateriasPrimasCarta(query) {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
          query: query
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl +
            "delivery/searchMateriasPrimasCartaByProductCarta",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.listSearchMateriasPrimas = response.data.result;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getMateriasPrimasByProduct() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idProduct: this.idProducto,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl +
            "delivery/getMateriasPrimasByProductCarta",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.listMateriasPrimas = response.data.result;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    addMateriaPrima() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        idMateriaPrima: this.idMateriaPrima,
        idProduct: this.idProducto,
        jwt: this.$store.getters.jwt,
      };
      this.idMateriaPrima = "";
      let vm = this;
      let controller = "addMateriaPrima";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.idMateriaPrima = "";

            vm.getMateriasPrimasByProduct();

            let notify = vm.$t("agregada");
            vm.$notify({
              message:
                vm.$t("relacion") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.searchMateriasPrimasCarta();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    addMateriaPrimaWhenEdit(materiaPrima) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        materiaPrima: materiaPrima,
        idProduct: this.idProducto,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "addMateriaPrimaWhenEdit";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          //console.log(response)
          if (response.data.response) {
            vm.idMateriaPrima = "";

            vm.getMateriasPrimasByProduct();

            let notify = vm.$t("editada");
            vm.$notify({
              message:
                vm.$t("relacion") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    changeTipo(entrada, materiaPrima) {
      var constError = 0;

      if (entrada === 1) {
        if (this.tipoAnterior === "") {
          this.tipoAnterior = materiaPrima.tipo;
        } else {
          this.tipoAnterior = "";
        }
      } else {
        this.listMateriasPrimas.forEach(function(x) {
          if (
            x.idSubproduct === materiaPrima.idSubproduct &&
            x.tipo === materiaPrima.tipo
          ) {
            constError++;
          }
        });

        if (constError > 1) {
          materiaPrima.tipo = this.tipoAnterior;

          swal({
            title: this.$t("atencion"),
            text: this.$t("noPuedeHaberDosMateriasPrimasConElMismoTipo"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.eliminarCrearSubproducto(materiaPrima);
          //this.guardarMateriaPrimaByProductosCarta(materiaPrima);
        }
      }
    },
    eliminarCrearSubproducto(materiaPrima) {
      //console.log(materiaPrima)
      this.eliminarSubproduct(materiaPrima.id);
      this.addMateriaPrimaWhenEdit(materiaPrima);
    },
    eliminarSubproducto(index) {
      swal({
        title: this.$t("estasSeguroDeBorrarLaMateriaPrima"),
        text: this.$t("estaOperacionNoSePuedeDeshacer"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siDeseoBorrarlo"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.eliminarSubproduct(index);
        }
      });
    },
    eliminarSubproduct(id) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        id: id,
        idBusiness: this.idBusiness,
        idProduct: this.idProducto,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "deleteMateriaPrimaByProductCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getMateriasPrimasByProduct();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    guardarMateriaPrimaByProductosCarta(obj) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        materiaPrima: obj,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "editMateriaPrimaByProductCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            let notify = vm.$t("editada");
            vm.$notify({
              message:
                vm.$t("relacion") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
  },
};
</script>

<style scoped>
/* .destacadoIcon {
  transition: transform 0.2s;
}
.destacadoIcon:active {
  transform: rotate(720deg);
}

.destacadoIcon:visited {
  transform: rotate(720deg);
} */

.destaFalse {
  color: #b1b1b1;
  transition: color 0.3s ease-out;
}
.destaTrue {
  color: #e6b000;
  transition: color 0.3s ease-out;
}

.card {
  padding: 20px;
}

.tab-content {
  margin-top: 0px;
}
.el-switch {
  margin: 15px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Productos/ProductoCarta.vue